import InfoIcon from "../../home/icons/InfoIcon";

const ShowErrorMessage = ({ errorMessage }: { errorMessage: string }) => {
  return (
    <div className="flex items-center gap-1 mt-1">
      <InfoIcon fill="#D35500" />
      <small className="text-red-500 text-[12px] font-normal">
        {errorMessage}
      </small>
    </div>
  );
};

export default ShowErrorMessage;
